/**
 * D118 (owner, 2026-10-20) — an app's databases.json can't be read, so its databases are held back: the AUTHOR is told
 * where and why. One badge for the drive row (the app folder and the databases.json file itself) and the app's card on
 * the PDApps page; the server sends the problem only to whoever can edit the app. The reason is in the tooltip; a
 * click opens the file to fix it.
 */
import { AlertTriangle } from 'lucide-react'
import { Tooltip } from '@papan/core-ui/ui'
import { useTranslation } from '@papan/i18n'

export interface ManifestProblem { path: string; reason: string; manifestRowId: string }

export function ManifestProblemBadge({ problem, onOpenFile, className }: {
  problem: ManifestProblem
  /** Open a file by id (the manifest). Absent → the badge only explains. */
  onOpenFile?: (fileId: string) => void
  className?: string
}) {
  const { t } = useTranslation('files')
  return (
    <Tooltip always content={t('driveView.manifestProblem.tooltip', { path: problem.path, reason: problem.reason })} className={className ?? 'shrink-0 inline-flex pointer-events-auto'}>
      <button
        type="button"
        data-testid="manifest-problem"
        aria-label={t('driveView.manifestProblem.tooltip', { path: problem.path, reason: problem.reason })}
        onClick={(e) => { e.stopPropagation(); onOpenFile?.(problem.manifestRowId) }}
        className="text-[10px] px-1.5 py-0.5 rounded-full whitespace-nowrap inline-flex items-center gap-1 hover:brightness-110"
        style={{ backgroundColor: 'rgba(251, 191, 36, 0.15)', color: '#fbbf24' }}
      >
        <AlertTriangle size={10} aria-hidden />
        {t('driveView.manifestProblem.badge')}
      </button>
    </Tooltip>
  )
}
